import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-intl-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";

import MainApp from "./MainApp";
import ErrorBoundary from "./ErrorBoundary";
import AirbrakeProvider from "./AirbrakeProvider";
import { ROOT_PATH } from "../constants/NavigationConstants";

export const renderPortal = ({ store, airbrake }) => {
  ReactDOM.render(
    <AirbrakeProvider airbrake={airbrake}>
      <ErrorBoundary>
        <Provider store={store}>
          <Router>
            <Route path={`${ROOT_PATH}`} component={MainApp} />
          </Router>
        </Provider>
      </ErrorBoundary>
    </AirbrakeProvider>,
    document.getElementById("root")
  );
};
